import { render, staticRenderFns } from "./ProductLocator.vue?vue&type=template&id=4fe7dafa&scoped=true&"
import script from "./ProductLocator.vue?vue&type=script&lang=js&"
export * from "./ProductLocator.vue?vue&type=script&lang=js&"
import style0 from "./ProductLocator.vue?vue&type=style&index=0&id=4fe7dafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe7dafa",
  null
  
)

export default component.exports